import React, { useEffect, useState, useContext } from "react";
import Loading from "../../Shared/Loading";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useParams } from 'react-router-dom';

import infynitoitem001 from "../../Shared/img/infynito-item001.svg";
import infynitoitem002 from "../../Shared/img/infynito-item002.svg";
import infynitoitem003 from "../../Shared/img/infynito-item003.svg";
import infynitoitem004 from "../../Shared/img/infynito-item004.svg";
import infynitoitem005 from "../../Shared/img/infynito-item005.svg";
import infynitoitem006 from "../../Shared/img/infynito-item006.svg";
import infynitoitem007 from "../../Shared/img/infynito-item007.svg";
import infynitoitem008 from "../../Shared/img/infynito-item008.svg";
import infynitoitem009 from "../../Shared/img/infynito-item009.svg";

import Grid from '@mui/material/Grid';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CloseIcon from '@mui/icons-material/Close';


import "./NavMenu.css";
import ModelContext from "../../ModelContext";
import LocalizationContext from "../../LocalizationContext";


export const NavMenu = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [classProfile, setClassProfile] = useState("350px");

    const { sectionId } = useParams();

    const [inputModelData, setInputModelData] = useState({
        idBasicModel: 0,
        idModel: 0,
        region: "",
        cultureCode: "",
        workingFolder: ""
    });

    const modelCtx = useContext(ModelContext);

    const isMobile = useMediaQuery('(max-width:480px)');
    const localizationCtx = useContext(LocalizationContext);
    const modelCode = props.modelCode;
    const currentCultureCode = props.cultureCode;

    const getModels = async () => {
        setIsLoading(true);
        const response = await fetch("/api/model/models/" + modelCode + "/" + currentCultureCode);

        if (response.ok) {
            const data = await response.json();
            if (data) {
                modelCtx.updateModelsData(data);
                setInputModelData({ ...inputModelData, idBasicModel: data[0].idbasicModel, idModel: data[0].idModel, region: "emea", cultureCode: currentCultureCode, workingFolder: data[0].workingFolder });
                modelCtx.updateInputModelData({ idBasicModel: data[0].idbasicModel, idModel: data[0].idModel, region: "emea", cultureCode: currentCultureCode, workingFolder: data[0].workingFolder });

            } else {
                //props.feedbackCallback("error", "Errore", true);
            }
        } else {
            const error = await response.text();
            //props.feedbackCallback("error", error, true);
        }
        setIsLoading(false);
    };


    useEffect(() => {
        getModels();

        window.addEventListener('scroll', function () {

            if (window.scrollY > 150) {
                setClassProfile("200px");
            } else {
                setClassProfile("350px");
            }
        });

        if (sectionId && sectionId !== "") {
            const element = document.getElementById(sectionId);
            let adjustment = 0;
            if (sectionId === "Exteriors") {
                adjustment = -20;
            }
            scrollToElement(element, adjustment);
        }

    }, []);




    const toggleDrawer = (open) => (event) => {
        if (
            event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }

        setIsOpen(open);
    };

    const drawerWidth = isMobile === true ? 370 : 480;

    const setOffsetTop = () => {
        let offset = 80;
        if (isMobile) {
            offset = 50;
        }
        return offset;
    };


    const handleClick = (anchorTag) => (event) => {

        const element = document.getElementById(anchorTag.replace("#", ""));
        scrollToElement(element, 0);

    };

    const scrollToElement = (element, adjustment) => {
        setTimeout(() => {
            window.scrollTo({
                behavior: element ? "smooth" : "auto",
                top: element ? element.offsetTop + adjustment - setOffsetTop() : 0
            });
        }, 100);
    }


    const menuList = () => {
        return (
            <Box
                sx={{ width: drawerWidth }}
                role="presentation"
                onClick={toggleDrawer(false)}
                onKeyDown={toggleDrawer(false)}
            >
                <Box sx={{ pt: 2, pb: 6 }}>
                    <IconButton
                        aria-label="close"
                        onClick={toggleDrawer(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <List>
                    <ListItem key="Introduction" disablePadding className="nav-item">
                        <ListItemButton onClick={handleClick("#Intro")}>
                            <ListItemIcon>
                                <img src={infynitoitem001} alt="" />
                            </ListItemIcon>
                            <ListItemText primary="Further than you can sea" classes={{ primary: 'nav-link text-truncate ms-1 d-inline' }} />
                        </ListItemButton>
                    </ListItem>

                    <ListItem key="Exteriors" disablePadding className="nav-item">
                        <ListItemButton onClick={handleClick("#Exteriors")}>
                            <ListItemIcon>
                                <img src={infynitoitem002} alt="" />
                            </ListItemIcon>
                            <ListItemText primary={currentCultureCode === "en-us" ? "Exteriors" : "Esterni"} classes={{ primary: 'nav-link text-truncate ms-1 d-inline' }} />
                        </ListItemButton>
                    </ListItem>

                    <ListItem key="Interiors" disablePadding className="nav-item">
                        <ListItemButton onClick={handleClick("#Interiors")}>
                            <ListItemIcon>
                                <img src={infynitoitem003} alt="" />
                            </ListItemIcon>
                            <ListItemText primary={currentCultureCode === "en-us" ? "Interiors" : "Interni"} classes={{ primary: 'nav-link text-truncate ms-1 d-inline' }} />
                        </ListItemButton>
                    </ListItem>

                    <ListItem key="Configurator" disablePadding className="nav-item">
                        <ListItemButton onClick={handleClick("#Configurator")}>
                            <ListItemIcon>
                                <img src={infynitoitem004} alt="" />
                            </ListItemIcon>
                            <ListItemText primary={currentCultureCode === "en-us" ? "Configurator" : "Configuratore"} classes={{ primary: 'nav-link text-truncate ms-1 d-inline' }} />
                        </ListItemButton>
                    </ListItem>

                    <ListItem key="BoatAnatomy" disablePadding className="nav-item">
                        <ListItemButton onClick={handleClick("#Boatanatomy")}>
                            <ListItemIcon>
                                <img src={infynitoitem005} alt="" />
                            </ListItemIcon>
                            <ListItemText primary="Boat Anatomy" classes={{ primary: 'nav-link text-truncate ms-1 d-inline' }} />
                        </ListItemButton>
                    </ListItem>

                    <ListItem key="Video" disablePadding className="nav-item">
                        <ListItemButton onClick={handleClick("#Videos")}>
                            <ListItemIcon>
                                <img src={infynitoitem006} alt="" />
                            </ListItemIcon>
                            <ListItemText primary="Video" classes={{ primary: 'nav-link text-truncate ms-1 d-inline' }} />
                        </ListItemButton>
                    </ListItem>

                    <ListItem key="Fsea" disablePadding className="nav-item">
                        <ListItemButton onClick={handleClick("#FseaSection")}>
                            <ListItemIcon>
                                <img src={infynitoitem007} alt="" />
                            </ListItemIcon>
                            <ListItemText primary={currentCultureCode === "en-us" ? "FSEA" : "FSEA"} classes={{ primary: 'nav-link text-truncate ms-1 d-inline' }} />
                        </ListItemButton>
                    </ListItem>

                    <ListItem key="TechData" disablePadding className="nav-item">
                        <ListItemButton onClick={handleClick("#Technical-data")}>
                            <ListItemIcon>
                                <img src={infynitoitem008} alt="" />
                            </ListItemIcon>
                            <ListItemText primary={currentCultureCode === "en-us" ? "Technical data" : "Dati tecnici"} classes={{ primary: 'nav-link text-truncate ms-1 d-inline' }} />
                        </ListItemButton>
                    </ListItem>

                    <ListItem key="Contacts" disablePadding className="nav-item">
                        <ListItemButton onClick={handleClick("#Contact-us")}>
                            <ListItemIcon>
                                <img src={infynitoitem009} alt="" />
                            </ListItemIcon>
                            <ListItemText primary={currentCultureCode === "en-us" ? "Contact us" : "Contatti"} classes={{ primary: 'nav-link text-truncate ms-1 d-inline' }} />
                        </ListItemButton>
                    </ListItem>

                </List>
            </Box>
        );
    };

    return (
        <>
            {isLoading && <Loading />}
            {!isLoading &&
                <AppBar
                    position="fixed"
                    sx={{ backgroundColor: "var(--color-ocean-light)" }}

                >
                    <Toolbar>
                        <Grid container spacing={0} direction="row" alignItems="center">
                            <Grid item xs={2} sm={2} md={2} sx={{textAlign: 'center' }}>

                                <IconButton
                                    size="large"
                                    edge="start"
                                    color="inherit"
                                    aria-label="menu"
                                    sx={{ mr: 2 }}
                                    onClick={toggleDrawer(true)}
                                >
                                    {!isOpen && <MenuIcon />}
                                    {isOpen && <MenuOpenIcon />}
                                </IconButton>
                            </Grid>

                            <Grid item md={2} sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }} >
                            </Grid>
                            <Grid item xs={10} sm={10} md={4} sx={{display: { xs: 'block', sm: 'block' }, textAlign: { xs: 'left', sm: 'left', md: 'center' }, verticalAlign: 'middle' }}>
                                <img src="/images/logo-infynito80-white.svg" className="logo-header" />
                            </Grid>
                            <Grid item xs={6} sm={6} md={4} sx={{ display: { xs: 'none', sm: 'none', md: 'block' }, textAlign: 'right' }}>
                                <img src="/images/profile-infynito80.png" className="scrolled" style={{ width: classProfile }} />
                            </Grid>
                        </Grid>



                        <SwipeableDrawer
                            anchor="left"
                            open={isOpen}
                            onClose={toggleDrawer(false)}
                            onOpen={toggleDrawer(true)}
                            classes={{
                                paper: 'menu-position',
                            }}

                        >
                            {menuList()}
                        </SwipeableDrawer>

                    </Toolbar>

                </AppBar>
            }
        </>
    );
};

export default NavMenu;
